/* eslint-disable-next-line no-unused-vars */
import StringScore from 'string_score/string_score';
import Config from './config';

export default class FuzzySearch {
  /**
   * Loops over the products list and returns a list of all fuzzy matches
   * @returns {Array} product objects
   */
  static getFuzzyMatches(productList, userInput) {
    const fuzzyMatches = [];

    productList.forEach((product) => {
      const productName = product.displayName;

      if (this.isFuzzyMatch(productName, userInput)) {
        fuzzyMatches.push(product);
      }
    });

    return fuzzyMatches;
  }

  /**
   * Is Fuzzy Match
   * Determines if a given user input matches a text string
   * Case- and space-insensitive. Uses the fuzzySearch library to decode
   * both parameters to replace special characters with their common equivalents or
   * remove them entirely before matching.
   * @param text {string} the text displayed in the autocomplete dropdown for each product
   * @param input {string} the text typed by the user
   * @returns {boolean}
   */
  static isFuzzyMatch(text, input) {
    const decodedText = FuzzySearch.searchifyString(text);
    const decodedInput = FuzzySearch.searchifyString(input);
    const decodedTextWithoutGarmin = FuzzySearch.removeGarmin(decodedText);
    const decodedInputWithoutGarmin = FuzzySearch.removeGarmin(decodedInput);
    const determineMatch = (searchifiedText, searchifiedInput) => (
      searchifiedText.indexOf(searchifiedInput, -1) > 0
      || searchifiedText.score(searchifiedInput) > Config.minimumStringMatchScore
    );

    if (!decodedText) return false;

    return (
      determineMatch(decodedText, decodedInput)
      || determineMatch(decodedTextWithoutGarmin, decodedInputWithoutGarmin)
    );
  }

  /**
   * Sanitize the input such that it can be easily compared against the product names in a reliable
   * fashion
   * @param {string} input
   * @returns {string}
   */
  static searchifyString(input) {
    if (!input) {
      return '';
    }

    let searchifiedString = input;

    if (searchifiedString) {
      searchifiedString = searchifiedString.toLowerCase();
    }

    searchifiedString = this.convertCharacters(searchifiedString);
    searchifiedString = this.removeWhitespace(searchifiedString);

    return searchifiedString;
  }

  /**
   * Convert special characters to their basic equivalents for easy string comparison
   * @param {string} input
   * @returns {string}
   */
  static convertCharacters(input) {
    let newInput = input;

    if (newInput && typeof newInput === 'string') {
      Object.keys(Config.specialCharacterConversions).forEach((specialChar) => {
        const regExpChar = new RegExp(specialChar, 'gi');
        const replacementChar = Config.specialCharacterConversions[specialChar];
        newInput = newInput.replace(regExpChar, replacementChar);
      });
    }

    return newInput;
  }

  /**
   * Removes whitespace from a given string
   * @param {string} input
   * @returns {string}
   */
  static removeWhitespace(input) {
    if (input && typeof input === 'string') {
      return input.replace(/\s/g, '');
    }

    return input;
  }

  /**
   * Removes garmin from a given string
   * @param {string} input
   * @returns {string}
   */
  static removeGarmin(input) {
    if (input && typeof input === 'string') {
      return input.replace(/garmin/gi, '');
    }

    return input;
  }
}
